import { VisStatusMessage } from './VisStatusMessage';
import { useTranslationBundle } from '../hooks/UNSAFE_useTranslationBundle';
import { BundleType } from '../resources/nls/bundle';
import { HTMLAttributesSignalExcluded } from '../utils/UNSAFE_attributeUtils';
import { getRandomId } from '../utils/PRIVATE_visLayoutUtils/LayoutUtils';

type Props = {
  'aria-label'?: HTMLAttributesSignalExcluded['aria-label'];
};

export function VisNoData(props: Props) {
  const translations = useTranslationBundle<BundleType>('@oracle/oraclejet-preact');
  const noDataMsg = translations.dataVisualization_noData();
  const activeId = getRandomId();

  return (
    <VisStatusMessage aria-label={props['aria-label']} activeId={activeId}>
      <span id={activeId}>{noDataMsg}</span>
    </VisStatusMessage>
  );
}
